<template>
  <div class="container sign-in" :class="{'container-white' : (color_theme === 'mobile' || color_theme === 'white'), 'container-black' : color_theme === 'black'}">
    <article class="intro">
      <h2 class="tit" :class="{'white' : (color_theme === 'mobile' || color_theme === 'white'), 'black' : color_theme === 'black'}">{{ $t('label.login') }}</h2>
      <p class="desc" :class="{'desc-white' : (color_theme === 'mobile' || color_theme === 'white'), 'desc-black' : color_theme === 'black'}" v-html="$t('messages.homeTxt')"></p>
    </article>
    <section class="sign-in-option" :class="{'white' : (color_theme === 'mobile' || color_theme === 'white'), 'black' : color_theme === 'black'}">
      <a href="#" class="thinq" :class="{'focusable': !showLanguage}" @click="goPage('QrLogin')" tabindex="0">
        {{ $t('label.qrLogin') }}
      </a>
      <a href="#" class="tv" :class="{'focusable': !showLanguage}" @click="goPage('Login')" tabindex="0">
        {{ theme === 'tv' ? $t('label.empFrontLogin') : $t('label.empLogin') }}
      </a>
    </section>
    <section class="select-lang">
      <label :class="{'white' : (color_theme === 'mobile' || color_theme === 'white'), 'black' : color_theme === 'black'}">{{ $t('label.selectCountry') }}</label>
      <button class="btn-lang focusable" @click="toggleLanguage" :class="{ 'active': showLanguage, 'inactive': !showLanguage, 'btn-lang-white' : color_theme === 'mobile', 'btn-lang-black' : color_theme === 'black'}" tabindex="0">{{ $t(`country.${country_code}`) }}</button>
      <div class="country-list" v-show="showLanguage" :class="{'white' : (color_theme === 'mobile' || color_theme === 'white'), 'black' : color_theme === 'black'}">
        <perfect-scrollbar class="inner">
          <ul>
            <li><a href="#" @click="setCountry('US')" :class="{'focusable': showLanguage}" tabindex="0">{{ $t('country.US') }}</a></li>
            <li><a href="#" @click="setCountry('CA')" :class="{'focusable': showLanguage}" tabindex="0">{{ $t('country.CA') }}</a></li>
            <li><a href="#" @click="setCountry('KR')" :class="{'focusable': showLanguage}" tabindex="0">{{ $t('country.KR') }}</a></li>
<!--            <li><a href="#" @click="setCountry('FR')" :class="{'focusable': showLanguage}" tabindex="0">{{ $t('country.FR') }}</a></li>-->
<!--            <li><a href="#" @click="setCountry('SP')" :class="{'focusable': showLanguage}" tabindex="0">{{ $t('country.SP') }}</a></li>-->
          </ul>
        </perfect-scrollbar>
      </div>
    </section>
  </div>
</template>

<script>
import session from "@/utils/session";

export default {
  name: 'Home',
  metaInfo() {
    return {
      title: "Home"
    };
  },
  data() {
    return {
      slide: 0,
      sliding: false,
      loginType: 'qrCode',
      color_theme: this.$store.state.color_theme || this.$route.query.color_theme || 'black',
      country_code: 'US',
      country_list: {
        'KR': 'ko',
        'US': 'en',
        'CA': 'en',
        // 'FR': 'fr',
        // 'SP': 'sp'
      },
      showLanguage: false,
      theme: session.get_theme() || 'tv',
    }
  },
  mounted() {
    const locale = navigator.language || navigator.userLanguage
    if (locale.includes('ko')) this.country_code = 'KR'
    else if(locale.includes('us')) this.country_code = 'US'
    // else if(locale.includes('ca')) this.country_code = 'CA'
    // else if(locale.includes('fr')) this.country_code = 'FR'
    // else if(locale.includes('sp')) this.country_code = 'SP'

    if (locale.indexOf('CA') < 0) {
      //GA User Info Logging
      gtag('config', process.env.VUE_APP_GA_ID, {
        'country_code': this.country_code
      });
    }

    if (this.$route.query.redirect_uri) {
      session.set_loginInfo(JSON.stringify({
        redirect_uri: this.$route.query.redirect_uri,
        country: this.country_code
      }))

      this.initLoginInfo({
        login_save: this.$route.query.login_save || this.$store.state.login_save || '',
        redirect_uri: this.$route.query.redirect_uri || this.$store.state.redirect_uri,
        country: this.country_code
      });

      this.initQueryInfo(this.$route.query)

      if (!this.$store.state.idpw) {
        this.goPage('QrLogin')
      }
    } else {
      let data = JSON.parse(session.get_loginInfo());
      if (data) {
        this.initLoginInfo(data);
      } else {
        this.goPage('LoginError')
      }
    }
    this.$route.query.return_type !== '' ? this.$store.dispatch('setReturnType', this.$route.query.return_type) : null
    this.$route.query.color_theme === 'mobile' ? this.goPage('QrLogin') : null
  },
  methods: {
    goPage: function(page) {
      const type = this.$store.state.color_theme
      this.$router.push({
        name: type === 'mobile' ? 'MobileLogin' : page,
        query: {
          country: this.$store.state.country,
          color_theme: this.$store.state.color_theme,
          display: this.$store.state.display,
          login_save: this.$store.state.login_save,
          redirect_uri: this.$store.state.redirect_uri,
          return_type: this.$store.state.return_type
        }
      });
    },
    initLoginInfo(data) {
      let login_save = data.hasOwnProperty('login_save') ? data.login_save : true;
      this.$store.dispatch('setLoginSave', login_save);
      this.$store.dispatch('setRedirectUri', data.redirect_uri);
      this.$store.dispatch('setReturnType', data.return_type);
      this.$store.dispatch('setCountryCode', data.country);
      this.redirect_uri = data.redirect_uri;
      this.country_code = data.country;
      // this.$i18n.locale = this.country_list[this.country_code]
      this.$i18n.locale = (data.country === 'KR') ? 'ko' : 'en';
    },
    setCountry(country) {
      this.showLanguage = false;
      this.country_code = country;
      // this.$i18n.locale = this.country_list[this.country_code]
      this.$i18n.locale = (this.country_code === 'KR') ? 'ko' : 'en';
      this.$store.dispatch('setCountryCode', this.country_code);
      session.set_loginInfo(JSON.stringify({
        redirect_uri: this.redirect_uri,
        country: this.country_code
      }))

      const locale = navigator.language || navigator.userLanguage;
      if (locale.indexOf('CA') < 0) {
        //GA User Info Logging
        gtag('config', process.env.VUE_APP_GA_ID, {
          'country_code': this.country_code
        });
      }
    },
    toggleLanguage: function() {
      this.showLanguage = !this.showLanguage;
    },
    initQueryInfo(query) {
      if(query.svc_list)this.$store.dispatch('setSvcList', query.svc_list);
      if(query.language)this.$store.dispatch('setLanguage', query.language);
      if(query.color_theme)this.$store.dispatch('setColorTheme', query.color_theme);
      else this.$store.dispatch('setColorTheme', 'black');
      if(query.display)this.$store.dispatch('setDisplayType', query.display);
      else this.$store.dispatch('setDisplayType', '');
      if(query.cross_login)this.$store.dispatch('setCrossLogin', query.cross_login);
      if(query.except_new)this.$store.dispatch('setExceptNew', query.except_new);
      if(query.terms_name)this.$store.dispatch('setTermsName', query.terms_name);
      if(query.third_party_service_name)this.$store.dispatch('setThirdPartyServiceName', query.third_party_service_name);
      if(query.show_login_type)this.$store.dispatch('setShowLoginType', query.show_login_type);
      if(query.response_type)this.$store.dispatch('setResponseType', query.response_type);
      if(query.return_type)this.$store.dispatch('setReturnType', query.return_type);
      if(query.client_id)this.$store.dispatch('setClientId', query.client_id);
      if(query.state)this.$store.dispatch('setState', query.state);
      if(query.idpw)this.$store.dispatch('setIdpw', query.idpw);
      if(query.dt)this.$store.dispatch('setQrDt', query.dt);
      if(query.tc)this.$store.dispatch('setQrTc', query.tc);
      if(query.rp)this.$store.dispatch('setQrRp', query.rp);
      if(query.tm)this.$store.dispatch('setQrTm', query.tm);
      if(query.sn)this.$store.dispatch('setQrSn', query.sn);
      if(query.sm)this.$store.dispatch('setQrSm', query.sm);
    },
  },
  computed: {
    country_code_options: function() {
      return [
        {value: 'US', text: this.$i18n.t('country.US')},
        {value: 'CA', text: this.$i18n.t('country.CA')},
        {value: 'KR', text: this.$i18n.t('country.KR')},
        // {value: 'FR', text: this.$i18n.t('country.FR')},
        // {value: 'SP', text: this.$i18n.t('country.SP')}
      ]
    }
  },
}
</script>
